var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch-helper/~/lodash/_DataView.js
// module id = 161
// module chunks = 0